import { render, staticRenderFns } from "./oldOrderDetails.vue?vue&type=template&id=8f1e9324&lang=pug"
import script from "./oldOrderDetails.vue?vue&type=script&lang=js"
export * from "./oldOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./oldOrderDetails.vue?vue&type=style&index=0&id=8f1e9324&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports